import React from 'react'
import PropTypes from 'prop-types'
import PlanStatusIcon from '../badges/PlanStatusIcon'

function PlanCard ({ plan, cardLabel, statusStyleOverrides, children }) {
  return (
    <div className='__header-wrapper flex flex-col'>
      <div className='__header flex items-center font-bold'>
        <div className='__status'>
          <PlanStatusIcon status={plan.status} size={23} statusStyleOverrides={statusStyleOverrides} />
        </div>
        <span>{cardLabel}</span>
      </div>
      {children}
    </div>
  )
}

PlanCard.propTypes = {
  plan: PropTypes.shape({
    name: PropTypes.string,
    status: PropTypes.string
  }).isRequired,
  cardLabel: PropTypes.string,
  statusStyleOverrides: PropTypes.object,
  children: PropTypes.node
}

PlanCard.defaultProps = {
  cardLabel: 'The Plan'
}

export default PlanCard
